export default (editor, opts = {}) => {
    const DOMC = editor.DomComponents;
    const TYPE = DOMC.getType("text");
    const MODEL = TYPE.model;
    const VIEW = TYPE.view;

    const TYPE_NAME = "APPLICATION-COREGISTRATION-REQUEST-BUTTON";
    const CATEGORY = "ADVANCE COMPONENT";
    const DATA_TYPE_ATTR_NAME = "data-lg-type";
    DOMC.addType(`C-${TYPE_NAME}`, {
        isComponent(el) {
            if (
                el &&
                el.getAttribute &&
                el.getAttribute(DATA_TYPE_ATTR_NAME) == `C-${TYPE_NAME}`
            )
                return { type: `C-${TYPE_NAME}` };
        },
        extend: "text",
        model: {
            defaults: {
                ...MODEL.prototype.defaults,
                "custom-name": `C-${TYPE_NAME}`,
                attributes: {
                    [DATA_TYPE_ATTR_NAME]: `C-${TYPE_NAME}`,
                },
                tagName: 'button',
                editable: true,
                classes: ["btn", "btn-primary"],
                content: "request",
                traits: MODEL.prototype.defaults.traits.concat([
                    {
                        type: "text",
                        placeholder: "Text after request",
                        name: "data-lg-text-after-request",
                        label: "Text after request",
                    }
                ]),
            },
        },
    });
};
